import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './home.component';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { ButtonModule } from 'primeng/button';
import { AccordionModule } from 'primeng/accordion';
import { WelcomeDialogModule } from '../welcome-dialog/welcome-dialog.module';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { Title } from '@angular/platform-browser';
import { MenuModule } from 'primeng/menu';
import { DrawerModule } from 'primeng/drawer';
import { DialogService } from 'primeng/dynamicdialog';
import { TermsOfUseModule } from '../terms-of-use/terms-of-use.module';

@NgModule({
  declarations: [
    HomeComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forRoot([]),
    TranslocoModule,
    ButtonModule,
    AccordionModule,
    WelcomeDialogModule,
    TieredMenuModule,
    AvatarModule,
    AvatarGroupModule,
    ScrollPanelModule,
    MenuModule,
    DrawerModule,
    TermsOfUseModule
  ],
  exports: [
    HomeComponent
  ],
  providers:[
    Title,
    DialogService
  ]
})
export class HomeModule { }
